/*
 * @Description:
 * @Author: kangkang
 * @Date: 2022-06-23 23:24:11
 * @LastEditTime: 2023-04-11 00:36:27
 * @LastEditors: kangkang
 * @Reference:
 */
export default {
    getWxAuthorize: {
        method: "POST",
        url: "/api/auth/wxAuthorize",
        name: "微信授权接口"
    },
    getWxUserByCode: {
        method: "POST",
        url: "/api/auth/getWxUserByCode",
        name: "获取用户信息"
    },
    getToken: {
        method: "POST",
        url: "/api/auth/getToken",
        name: "获取token"
    },
    getRefreshToken: {
        method: "POST",
        url: "/api/auth/refreshToken",
        name: "刷新token"
    },
    getAppellationList: {
        method: "POST",
        url: "/api/comm/getAppellationList",
        name: "称谓列表接口"
    },
    getSuspensiveWordsList: {
        method: "POST",
        url: "/api/comm/getSuspensiveWordsList",
        name: "获取悼念词列表接口"
    },
    getBackVideoList: {
        method: "POST",
        url: "/api/comm/getBackVideoList",
        name: "获取背景视屏列表"
    },
    uploadImage: {
        method: "POST",
        url: "/api/upload/image",
        name: "上传图片接口"
    },
    orderCreate: {
        method: "POST",
        url: "/api/order/create",
        name: "下单接口"
    },
    payConfig: {
        method: "POST",
        url: "/api/pay/config",
        name: "微信支付签名接口"
    },
    orderLists: {
        method: "POST",
        url: "/api/order/lists",
        name: "我的订单列表接口"
    },
    orderInfo: {
        method: "POST",
        url: "/api/order/info",
        name: "往期信息详情接口"
    },
    orderEdit: {
        method: "POST",
        url: "/api/order/edit",
        name: "编辑往期信息接口"
    }
};
